import { PROFILE, ADD_POST } from '../../../../constants/routes';
import { ProfileSchema } from './ProfileSchema';
import { updateUserProfile } from '../../../../reducers/auth/auth.actions';
import { getLaravelValidationErrors } from '../../../../helpers';

const formik = ({ dispatch, history, shouldUploadAvatar, user, setShowSavePopup, afterChange }) => {
  return {
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      name: '',
      nickname: '',
      subscription_price: '',
      about: '',
      subscription_message: '',
      location: '',
      website: '',
      avatar: { file: null, url: '' },
      cover: { file: null, url: '' },
    },
    validationSchema: ProfileSchema,
    onSubmit: (values, { setStatus, setSubmitting, setErrors }) => {
      console.log('Form onSubmit triggered with values:', values);
      console.log('Avatar file:', values.avatar?.file);
      console.log('Cover file:', values.cover?.file);

      dispatch(
        updateUserProfile(values.id, {
          ...values,
          avatar: values.avatar.file ? values.avatar.file : null,
          cover: values.cover.file ? values.cover.file : null,
        })
      )
        .then(resp => {
          console.log('Profile update successful:', resp);
          shouldUploadAvatar && resp.verification_status === 'verified' &&
            history.push(ADD_POST)

          setShowSavePopup(true)
          afterChange();
          setTimeout(() => {
            setShowSavePopup(false);
          }, 3000);
          setSubmitting(false);
        })

        .catch(response => {
          console.error('Profile update failed:', response);

          if (response?.errors) {
            setErrors(response.errors)
            setStatus({ errors: getLaravelValidationErrors(response), });
          } else if (response?.message) {
            console.error('Upload error message:', response.message);
            setStatus({ errors: [response.message] });
          } else {
            console.error('Unknown upload error:', response);
            setStatus({ errors: ['Failed to upload profile picture. Please check your connection and try again.'] });
          }
          setSubmitting(false);
        });
      setSubmitting(true);
    },
  };
};

export default formik;
